$(function(){
	$(".tile-list").each(function(){
        var bgColor = $(this).data("background");
        if (bgColor) {
            $(this).css("background-color", bgColor);
        }
    })
});

